import { render, staticRenderFns } from "./OfferingInventory.vue?vue&type=template&id=c90ad98e&scoped=true"
import script from "./OfferingInventory.vue?vue&type=script&lang=js"
export * from "./OfferingInventory.vue?vue&type=script&lang=js"
import style0 from "./OfferingInventory.vue?vue&type=style&index=0&id=c90ad98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90ad98e",
  null
  
)

export default component.exports